var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-wrapper',{attrs:{"title":_vm.option.title,"description":_vm.option.description,"isFirst":_vm.isFirst,"isLast":_vm.isLast},on:{"submit":function($event){_vm.submit()},"previous":function($event){_vm.previous()}}})}
var staticRenderFns = []

export { render, staticRenderFns }